import axios from 'axios';
import { mapboxToken } from 'constants/Mapbox';

const baseURL = 'https://api.mapbox.com';
const headers = { 'Content-Type': 'application/json' };

const http = axios.create({ baseURL, headers });

export const getHumanizedAddress = (trackerLog) => {
  const latitude = trackerLog.geometry.coordinates[1];
  const longitude = trackerLog.geometry.coordinates[0];
  return http
    .get(
      `/geocoding/v5/mapbox.places/${longitude},${latitude}.json?types=address,place&language=es&access_token=${mapboxToken}`
    )
    .then((response) => {
      const address = response.data.features;
      const placeName = `${address && address.length ? address[0].text_es : ''}${
        address && address[0] && address[0].address ? ' ' : ''
      }${address && address[0] && address[0].address ? address[0].address : ''}, ${
        address[1] ? address[1].place_name_es : ''
      }`;
      return placeName;
    });
};
